import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'mojo-job-salary-full-time',
  templateUrl: './job-salary-full-time.component.html',
  styleUrls: ['./job-salary-full-time.component.scss'],
})
export class JobSalaryFullTimeFormComponent {
  @Input() form: UntypedFormGroup;
  @Input() isSowJobType = false;
}
